
export default function HeroSection() {
  return (
    <section id="hero-section" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Fondo estrellado animado */}
      <div className="absolute inset-0 bg-black">
        <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-900/50 to-black"></div>
        {/* Estrellas doradas */}
        {[...Array(50)].map((_, i) => (
          <div
            key={i}
            className="absolute animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${2 + Math.random() * 2}s`
            }}
          >
            <div className="w-0.5 h-0.5 sm:w-1 sm:h-1 rounded-full bg-gold-500 shadow-lg" style={{ boxShadow: '0 0 10px #d5ab4c80' }}></div>
          </div>
        ))}

        {/* Destellos mágicos más grandes */}
        {[...Array(15)].map((_, i) => (
          <div
            key={`sparkle-${i}`}
            className="absolute animate-ping"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 4}s`,
              animationDuration: `${3 + Math.random() * 2}s`
            }}
          >
            <div className="w-1 h-1 sm:w-2 sm:h-2 rounded-full bg-gold-500 shadow-xl" style={{ boxShadow: '0 0 20px #d5ab4c70' }}></div>
          </div>
        ))}
      </div>

      {/* Contenido principal */}
      <div className="relative z-10 text-center px-3 sm:px-4 md:px-6 lg:px-8 max-w-7xl mx-auto w-full">
        {/* Logo */}
        <div className="mb-3 sm:mb-4 md:mb-6 lg:mb-8">
          <img 
            src="https://static.readdy.ai/image/d7e77f925f0119a01fe5d8699c3ff655/df42e42088fea8669f9dab7c63fea457.png" 
            alt="Starlight Christmas Photo Session" 
            className="w-64 sm:w-72 md:w-80 lg:w-96 xl:w-[500px] 2xl:w-[600px] 3xl:w-[700px] h-auto mx-auto drop-shadow-2xl max-w-full"
          />
        </div>

        {/* Slogan */}
        <div className="mb-6 sm:mb-8 md:mb-12 lg:mb-16">
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl text-gray-200 leading-relaxed font-sans font-light max-w-5xl mx-auto px-2">
            Ilumina tu Navidad con recuerdos que brillan para siempre.
          </p>
        </div>

        {/* Elementos decorativos */}
        <div className="flex justify-center items-center space-x-3 sm:space-x-4 md:space-x-6 lg:space-x-8 mt-6 sm:mt-8 md:mt-12 lg:mt-16">
          <div className="w-8 sm:w-12 md:w-16 lg:w-20 h-px bg-gradient-to-r from-transparent via-gold-500 to-transparent"></div>
          <div className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10 flex items-center justify-center">
            <i className="ri-star-fill text-xl sm:text-2xl md:text-3xl lg:text-4xl text-gold-500 animate-pulse"></i>
          </div>
          <div className="w-8 sm:w-12 md:w-16 lg:w-20 h-px bg-gradient-to-r from-transparent via-gold-500 to-transparent"></div>
        </div>
      </div>

      {/* Indicador de scroll */}
      <div className="absolute bottom-4 sm:bottom-6 md:bottom-8 lg:bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-5 sm:w-6 md:w-7 lg:w-8 h-8 sm:h-10 md:h-12 lg:h-14 border-2 border-gold-500 rounded-full flex justify-center">
          <div className="w-0.5 sm:w-1 h-2 sm:h-3 md:h-4 lg:h-5 bg-gold-500 rounded-full mt-1.5 sm:mt-2 md:mt-3 lg:mt-4 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
}
